<template>
    <div>

        <div class="bg-white rounded">
            <div class="table pt-3 mb-0">
                <div class="add_license d-flex justify-content-between align-items-center flex-wrap mb-3 px-3">
                    <h3 class="font-weight-bold f-20 text-left mb-0 text-black">{{ $t('recordsAndTotal.types') }}</h3>
                    <b-button @click="$bvModal.show('type-modal')" v-if="allowAddData"
                        class="export equipment d-flex justify-content-center align-items-center w-fit-content"
                        variant="primary">
                        <b-icon icon="plus" class="p-0" aria-hidden="true"></b-icon>
                        <p class="mb-0 ml-2 text-white p-0">{{ $t('recordsAndTotal.addPrefix') }} {{ $t('recordsAndTotal.addType') }}</p>
                    </b-button>
                </div>
                <b-table responsive :sticky-header="'calc(100vh - 270px)'" :fields="translatedFields" :items="items" hover
                    :per-page="perPage" :current-page="currentPage" show-empty>
                    <template #cell(action)="data">
                        <div v-if="allowUpdateTypes || allowDeleteTypes">
                            <svg @click="editTypeItem(data.item)" v-if="allowUpdateTypes" class="mr-4 cursor-pointer"
                                width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M5.52719 16.7477L14.5274 7.74753L10.2525 3.4726L1.25226 12.4728C1.12836 12.5969 1.04034 12.7522 0.997548 12.9222L0 18L5.07684 17.0025C5.2473 16.9598 5.40322 16.8717 5.52719 16.7477V16.7477ZM17.4329 4.84205C17.796 4.47881 18 3.98622 18 3.4726C18 2.95898 17.796 2.46639 17.4329 2.10315L15.8968 0.567123C15.5336 0.203994 15.041 0 14.5274 0C14.0138 0 13.5212 0.203994 13.1579 0.567123L11.6219 2.10315L15.8968 6.37808L17.4329 4.84205Z"
                                    fill="#2CCE89" />
                            </svg>
                            <svg @click="showTypeDeletePopup(data.item.id)" v-if="allowDeleteTypes" class="cursor-pointer"
                                width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                    stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                    stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                        <span v-else> - </span>
                    </template>
                </b-table>
                <div class="entries-pagination px-0 px-sm-2">
                    <div class="d-flex align-items-center flex-wrap">
                        <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                            <b-form-select v-model="perPage" :options="pageOptions" />
                        </div>
                        <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">{{ positionText }}</p>
                        <div class="pagination">
                            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                                aria-controls="my-table"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
            <b-modal id="type-modal" centered no-close-on-backdrop :footer-class="'d-block p-3 m-0'"
                :body-class="'equipment-edit-modal'" no-close-on-esc>
                <template #modal-header="{ close }">
                    <h5 class="modal-title">
                        {{ editType ? $t('maintenanceTypes.editTitle') : $t('maintenanceTypes.addTitle') }}
                    </h5>
                    <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                        Close Modal
                    </b-button>
                </template>
                <div class="body">
                    <b-row>
                        <b-col cols="12" class="mt-3">
                            <b-form-group :label="$t('maintenanceTypes.typeLabel')" class="text-left mb-0">
                                <b-form-input v-model="type"
                                    :disabled="!allowAddData && (!editType || (editType && !allowUpdateTypes))"
                                    :placeholder="$t('maintenanceTypes.typePlaceholder')" class="unit"
                                    required></b-form-input>
                                <p v-if="typeError" class="field-error mb-lg-3">
                                    {{ typeError }}
                                </p>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                <template #modal-footer>
                    <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 mx-0">
                        <b-button class="mx-0 h-40px w-100px m-0"
                            :class="(allowAddData && !editType) || (editType && allowUpdateTypes) ? 'mr-3' : ''"
                            @click="resetForm()" variant="secondary">{{ $t('maintenanceShared.cancel') }}</b-button>
                        <div class="d-flex align-items m-0"
                            v-if="(allowAddData && !editType) || (editType && allowUpdateTypes)">
                            <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary" @click="updateTypeData()">{{
                                editType ?
                                $t('maintenanceShared.save') : $t('maintenanceTypes.addType') }}</b-button>
                        </div>
                    </div>
                </template>
            </b-modal>
            <DeleteModal v-if="showDeletePopup" @confirm="deleteItem($event)" />

        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import DeleteModal from "@/components/DeleteModal.vue";
export default {
    name: "Types",
    components: { DeleteModal },
    data() {
        return {
            type: null,
            typeID: null,
            perPage: 25,
            allowAddType: false,
            showDeletePopup: false,
            items: [],
            currentPage: 1,
            editType: false,
            typeError: "",
            pageOptions: [
                {
                    value: 10,
                    text: "10",
                },
                {
                    value: 25,
                    text: "25",
                },
                {
                    value: 50,
                    text: "50",
                },
                {
                    value: 100,
                    text: "100",
                },
            ],
        }
    },
    computed: {
        ...mapGetters(["rolePermissions", "userCompany", "types"]),
        translatedFields() {
            return [
                { key: "name", label: this.$t('maintenanceTypes.columnType'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "Action", sortable: true, thClass: 'font-table-weight-bold' },
            ];
        },
        allowAddData() {
            return this.rolePermissions && this.rolePermissions['Maintenance'] && this.rolePermissions['Maintenance'][2].allow
        },
        allowUpdateTypes() {
            return this.rolePermissions && this.rolePermissions['Maintenance'] && this.rolePermissions['Maintenance'][1].allow
        },
        allowDeleteTypes() {
            return this.rolePermissions && this.rolePermissions['Maintenance'] && this.rolePermissions['Maintenance'][3].allow
        },
        rows() {
            return this.items.length;
        },
        positionText() {
            const endIndex = this.currentPage * this.perPage;
            const startIndex = this.rows > 0 ? (this.currentPage - 1) * this.perPage + 1 : 0;
            const end = endIndex > this.rows ? this.rows : endIndex;
            return this.$t('maintenanceShared.positionText', { start: startIndex, end, total: this.rows });
        }
    },
    watch: {
        allowAddType() {
            if (this.allowAddType) {
                this.$bvModal.show('type-modal')
            }
        }
    },
    methods: {
        ...mapActions([
            "getAllTypes",
            "setNotification",
            "updateType",
            "addType",
            "deleteType",
        ]),
        async deleteItem(status) {
            if (status) {
                try {
                    await this.deleteType(`${this.typeID}/?company_id=${this.userCompany}`)
                    await this.setNotification({
                        msg: this.$t('maintenanceTypes.typeDeleted'),
                        type: "success",
                        color: "green",
                    });
                    this.typeID = null
                    this.showDeletePopup = false;
                    await this.getTypes()
                }
                catch (e) {
                    console.log(e)
                }
            }
            else this.showDeletePopup = false
        },
        resetForm() {
            this.typeError = ""
            this.$bvModal.hide('type-modal')
            this.type = null
            this.typeID = null
            this.$emit('close')
            this.editType = false

        },
        editTypeItem(data) {
            this.editType = true
            this.type = data.name
            this.typeID = data.id
            this.$bvModal.show('type-modal')
        },
        showTypeDeletePopup(id) {
            this.showDeletePopup = true;
            this.typeID = id;
        },
        async getTypes() {
            try {
                await this.getAllTypes(this.userCompany);
                this.items = [];
                this.types.map((type) => {
                    this.items.push({
                        name: type.name,
                        id: type.id
                    })
                })
            }
            catch (e) {
                console.log(e)
            }
        },
        async updateTypeData() {
            if (this.type) {
                let successMsg = this.$t('maintenanceTypes.typeAdded')
                if (this.editType) {
                    successMsg = this.$t('maintenanceTypes.typeUpdated')
                    try {
                        await this.updateType({
                            id: this.typeID,
                            payload: {
                                name: this.type
                            }
                        })
                    }
                    catch (e) {
                        await this.setNotification({
                            msg: e,
                            type: "error",
                            color: "red",
                        });
                        return
                    }
                }
                else {
                    try {
                        await this.addType({ name: this.type, company: this.userCompany })
                    }
                    catch (e) {
                        await this.setNotification({
                            msg: e,
                            type: "error",
                            color: "red",
                        });
                        return
                    }
                }
                await this.setNotification({
                    msg: successMsg,
                    type: "success",
                    color: "green",
                });
                this.resetForm()
                await this.getTypes()
            }
            else {
                this.typeError = this.$t('maintenanceTypes.fieldRequired')
            }
        },
    },
    mounted() {
        this.getTypes();
    }
}
</script>